var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DateTimePicker from './DateTimePicker';
// TODO:
// 1. Watch min/max date.
let DatePicker = class DatePicker extends Vue {
    render(h) {
        return h(DateTimePicker, {
            props: {
                value: this.value,
                error: this.error,
                showTime: false,
                minDate: this.min,
                maxDate: this.max,
                format: this.format,
                withActionButtons: this.withActionButtons,
                clearAction: this.clearAction,
                placeholder: 'Select date',
                disabled: this.disabled
            },
            on: {
                input: this.onInput,
                open: this.onOpen
            }
        });
    }
    onInput(selectedDate, _dateStr, _instance) {
        this.$emit('input', selectedDate);
    }
    onOpen(selectedDate, _dateStr, _instance) {
        this.$emit('open', selectedDate);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Date)
], DatePicker.prototype, "value", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], DatePicker.prototype, "format", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], DatePicker.prototype, "error", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DatePicker.prototype, "withActionButtons", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Date)
], DatePicker.prototype, "min", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Date)
], DatePicker.prototype, "max", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DatePicker.prototype, "clearAction", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DatePicker.prototype, "disabled", void 0);
DatePicker = __decorate([
    Component({})
], DatePicker);
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map